export default __webpack_public_path__ + "static/MS-Sans-Serif-8pt-bold-885aa008d57a83ca13490c7160af429c.ttf";